import { config } from '@/pageConfig/giveback/us/en';
import { GivebackPageTemplate } from '@/pageTemplate/GivebackPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function GivebackPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(() => trackEvent('giveback_landing_page.viewed'), []);

  return <GivebackPageTemplate config={config} />;
}
